import { combineReducers } from 'redux'
import userInfo from './userInfo'
import chatInfo from './chatInfo'
import userPermission from './userPermission'
import errorStateInfo from './errorStateInfo'
import footerStateInfo from './footerStateInfo'
import bankAccountInfo from './bankAccountInfo'
import productDetailInfo from './productDetailInfo'
import eventModal from './eventModal'

export default combineReducers({
  userInfo,
  chatInfo,
  userPermission,
  errorStateInfo,
  footerStateInfo,
  bankAccountInfo,
  productDetailInfo,
  eventModal,
})
